import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ItemsListVariants extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const updated = event.detail.data.html.querySelector(
      `items-list-variants[data-section-id="${this.dataset.sectionId}"]`
    );

    if (!updated) return;
    morph(this, updated, { childrenOnly: true });

    this.#reinitSplide();
  };

  #reinitSplide() {
    const section = this.querySelector('[id^="items-list-"]');
    if (!section) return;
    const evt = new CustomEvent('shopify:section:load', { bubbles: true });
    section.dispatchEvent(evt);
  }
}

if (!customElements.get('items-list-variants')) {
  customElements.define('items-list-variants', ItemsListVariants);
}
